import { NavLink } from "react-router-dom";
import { FaHeart } from "react-icons/fa";
import ReactionBar from "../ui/ReactionBar";
import useMediaActions from "../../hooks/useMediaActions";
import { useAuth } from "../../features/auth/AuthContext";
import { MOVIE, detailPath, reactionTarget } from "../../lib/catalog";
import { truncate } from "../../lib/text";

/** Poster tile used inside the home rows. */
const MediaCard = ({ item }) => {
  const { isAuthenticated } = useAuth();
  const actions = useMediaActions(
    reactionTarget(item),
    item.id,
    item.user_action
  );

  const route = detailPath(item);
  const director = truncate(item.director?.[0]?.name ?? "نامعلوم", 15);

  return (
    <div className="group/card relative mr-3 inline-block h-[230px] w-[117px] align-top sm:h-[295px] sm:w-[140px] md:h-[360px] md:w-[200px]">
      <div className="relative h-[170px] w-full overflow-hidden rounded sm:h-[230px] md:h-[300px]">
        <NavLink to={route}>
          <img
            className="h-full w-full rounded object-cover"
            src={item.cover}
            alt={item.name}
            loading="lazy"
          />
          <div className="absolute inset-0 bg-black/30" />
        </NavLink>

        <div className="absolute inset-0 rounded bg-black/60 opacity-30 transition-opacity hover:opacity-100 sm:opacity-0">
          <NavLink
            to={route}
            className="absolute inset-0"
            aria-label={item.name}
          />

          {isAuthenticated && (
            <ReactionBar
              actions={actions}
              showReactions={item.type === MOVIE}
              size="text-base md:text-xl"
              className="absolute left-2 top-2 hidden sm:flex"
            />
          )}

          <div className="pointer-events-none absolute bottom-2 right-2 hidden text-left sm:block">
            {item.type === MOVIE && item.like_percent != null && (
              <p className="flex items-center justify-end gap-1">
                <FaHeart className="text-xl text-gray-300" />
                {item.like_percent}%
              </p>
            )}
            <p className="text-xs">کارگردان :{director}</p>
          </div>
        </div>
      </div>

      <NavLink to={route}>
        <p className="mr-1 mt-2 whitespace-pre-wrap text-base font-semibold leading-6 text-white md:text-lg md:leading-5">
          {item.name}
        </p>
      </NavLink>
    </div>
  );
};

export default MediaCard;
